import { render } from "./ReadOnlyView.vue?vue&type=template&id=64b396c4"
import script from "./ReadOnlyView.vue?vue&type=script&lang=js"
export * from "./ReadOnlyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__